import type { subscription as en } from '@/i18n/locales/en/subscription';
import type { Translation } from '@/i18n/types';

export const subscription: Translation<typeof en> = {
  title: 'Abonelik',
  lead: 'Kendi aboneliğinizi yönetin — plan, ödeme ve iptal.',
  dialogCancel: 'İptal',
  status: {
    title: 'Durum',
    active: 'Etkin',
    inactive: 'Etkin değil',
    tier: 'Plan',
    expires: 'Sona erme',
    autoRenews: 'Otomatik yenilenir',
    doesNotRenew: 'Yenilenmez',
    nextCharge: 'Sonraki ödeme',
    blocked: 'Şu anda bir web aboneliği başlatamazsınız.',
  },
  plans: {
    title: 'Planlar',
    monthly: 'Aylık',
    yearly: 'Yıllık',
    perMonth: '{{price}} / ay',
    perYear: '{{price}} / yıl',
    subscribe: 'Abone ol',
    current: 'Mevcut plan',
    switchToYearly: 'Yıllığa geç',
    switchToMonthly: 'Aylığa geç',
    switchWarning:
      'Geçiş, mevcut aboneliğinizi iptal eder ve yenisini aynı ödeme talimatıyla hemen başlatır. İki dönem arasındaki örtüşme geri ödenmez — bunun için iki kez ücretlendirilebilirsiniz.',
    switchConfirm: 'Evet, planı değiştir',
    blocked: 'Zaten etkin bir aboneliğiniz var, bu yüzden şu anda başka bir plan başlatılamaz.',
  },
  manage: {
    title: 'Yönet',
    cancel: 'Aboneliği iptal et',
    cancelConfirm: 'Evet, iptal et',
    cancelled: 'İptal edildi — erişim {{date}} tarihine kadar devam eder.',
    proRataNote:
      'Yıllık planda, ilk ödeme döneminden sonra iptal etmek, kullanılmayan tam ayları geri öder ve erişimi dönemin sonunda değil hemen sonlandırır.',
    withdraw: 'Cayma (14 gün içinde)',
    withdrawHint: 'İlk ödemenizden sonra 14 gün boyunca, abonelik başına bir kez kullanılabilir.',
  },
  history: {
    title: 'Geçmiş',
    empty: 'Henüz satın alma yok.',
    date: 'Tarih',
    period: 'Dönem',
    channel: 'Kanal',
    state: 'Durum',
    state_granted: 'Verildi',
    state_refunded: 'Geri ödendi',
    state_revoked: 'İptal edildi',
    state_charged_back: 'Ters ibraz',
    state_rejected: 'Reddedildi',
    invoice: 'Fatura',
    withdrawLink: 'Cayma',
    manageLink: 'Mağazada yönet',
  },
  checkout: {
    title: 'Ödeme',
    lead: 'Mollie’ye devam etmeden önce planınızı gözden geçirin.',
    plan: 'Plan',
    price: 'Fiyat',
    consentLabel:
      'Hizmetin hemen başlamasını istiyorum ve caymam durumunda, zaten kullanılmış olan kısım için orantılı ödeme yapacağımı anlıyorum.',
    start: 'Mollie’ye devam et',
    errorAlreadySubscribed: 'Zaten etkin bir aboneliğiniz var.',
    errorProductUnavailable: 'Bu plan şu anda kullanılamıyor.',
  },
  return: {
    title: 'Ödeme durumu',
    waiting: 'Ödeme onayını hâlâ bekliyoruz.',
    success: 'Ödeme alındı — aboneliğiniz etkin.',
    backToSubscription: 'Aboneliğinize geri dönün',
  },
  withdraw: {
    title: 'Aboneliğinizden cayın',
    lead: '14 günlük cayma hakkınız kapsamında cayma, erişiminizi hemen sonlandırır — halihazırda ödediğiniz dönemin sonuna kadar devam eden iptalden farklı olarak.',
    refundTypeFull: 'Tam geri ödeme alacaksınız.',
    refundTypeProRata: 'Henüz kullanılmayan kısım için orantılı geri ödeme alacaksınız.',
    refundAmount: 'Geri ödeme tutarı',
    deadline: 'Son tarih',
    confirm: 'Cay ve erişimi şimdi sonlandır',
    confirmed: 'Cayıldı — {{amount}} geri ödenecek.',
    errorWindowExpired: '14 günlük cayma süresi doldu.',
    errorAlreadyWithdrawn: 'Bu abonelikten zaten caydınız.',
  },
};
